import React, {
	useEffect, useRef, useState
}from "react"
import {
	Input, Form, Select, Button
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	mobileActions
}from "../store/actions"
import notice from "../../../components/Notice"
import "antd/lib/select/style/index.css"
import "./style.css"
import i18n from "../localization"
import i18nGlobal from "../../../localization"
import {
	CustomInput
}from "../../../components/CustomInput"

const MobilePhoneNumber = (props) => {
	const dispatch = useDispatch()
	const [phoneCode, setPhoneCode] = useState(null)
	const { initialNumber, initialPhoneCode, form, children, isNotToChange } = props
	const [mobilePhoneCodes, setPhoneCodes] = useState([])
	const { phoneCodes, getCodesError } = useSelector((state) => state.mobileReducer)
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const counter = useRef(0)

	// const [count, setCount] = useState(0);

	useEffect(() => {
		dispatch(mobileActions.getInternationalPhoneCodes({
			id: initialPhoneCode?.id
		}))
		if (initialPhoneCode){
			form.setFieldsValue({ phoneCode: initialPhoneCode })
			setPhoneCode(initialPhoneCode)
		}
		return () => {
			dispatch(mobileActions.clearPhoneCodes())
		}
	}, [])

	useEffect(() => {
		if (phoneCodes && !initialPhoneCode){
			const BY = phoneCodes.find((code) => {
				return code.value == "+375"
			})
			form.setFieldsValue({ phoneCode: BY })
			setPhoneCode(BY)
		}
		if (phoneCodes && phoneCodes.length)
			setPhoneCodes(phoneCodes)
	}, [phoneCodes])

	useEffect(() => {
		if (getCodesError)
			notice("error", getCodesError.errors)
	}, [getCodesError])

	const changePhoneCode = (id) => {
		const temp = getPhoneCode(id)
		setPhoneCode(temp)
		form.setFieldsValue({ phoneCode: temp })
	}

	const searchPhoneCode = (value) => {
		const temp = []
		phoneCodes.forEach((code) => {
			if (
				code.value.includes(value) ||
        code.reCountry.name.toUpperCase().includes(value.toUpperCase())
			)
				temp.push(code)
		})
		setPhoneCodes(temp)
	}

	useEffect(() => {
		if (counter.current > 1)
			form.validateFields(["mobilePhoneNumber"])

		else
			counter.current++
	}, [phoneCode])

	const getPhoneCode = (id) => {
		const temp = phoneCodes.find((obj) => {
			return obj.id === id
		})
		return temp
	}

	return (
		phoneCodes &&
    phoneCode && (
			<>
				<Form.Item
					initialValue={ initialNumber && initialNumber }
					label={ i18nGlobal.phone[isRu] }
					labelCol={ { span: 8 } }
					name="mobilePhoneNumber"
					rules={ [
						{
							message  : i18n.validatePhoneNumberMessage[isRu],
							pattern	 : new RegExp(`^\((25)|(29)|(33)|(44)|(16)|(17)|(15)|(21)|(22)|(23))[0-9]{${phoneCode.numberOfDigits - 2}}$`),
							required : !isNotToChange
						}
					] }
					wrapperCol={ { span: 15 } }
				>
					<CustomInput
						addonAfter={ children ? children[1] : null }
						addonBefore={
							(
								<Form.Item
									noStyle
									initialValue={
										initialNumber ? initialPhoneCode.id : phoneCode.id
									}
									name="phoneCodeId"
								>
									<Select
										showSearch
										defaultActiveFirstOption={ false }
										disabled={ isNotToChange }
										filterOption={ false }
										notFoundContent={ null }
										style={ { minWidth: "80px" } }
										onChange={ (e) => changePhoneCode(e) }
										onSearch={ (value) => {
											searchPhoneCode(value)
										} }
									>
										{ mobilePhoneCodes.map((e, i) => {
											return (
												<Select.Option
													key={ i }
													title={ `(${ e.reCountry.name }) ${ e.value }` }
													value={ e.id }
												>
													{ e.value }
												</Select.Option>
											)
										}) }
									</Select>
								</Form.Item>
							)
						}
						autoComplete="off"
						disabled={ isNotToChange }
						placeholder={ "X".repeat(phoneCode.numberOfDigits) }
						style={ { height: "auto" } }
						suffix={ children ? children[0] : null }
					/>
				</Form.Item>
				<Form.Item
					hidden
					name="phoneCode"
				/>
			</>
		)
	)
}

export default MobilePhoneNumber
